import { GetOneUserDto } from "../../dtos/user/GetOneUserDto";
import { getUserProfile } from "../../service/user/userService";

export async function LoggedInUserData(dispatch: any):Promise<GetOneUserDto> {
    const data: GetOneUserDto = await getUserProfile(dispatch);
    return data;
}